import $ from 'jquery';
import ComponentInitializers from 'components/shared/ComponentInitializers/ComponentInitializers';
import ShowMoreContent from 'shared/show_more_content';
import CommentVideoSection from 'shared/components/comment_video_section';
import 'timeago';

export default class ShowMoreReplies {
  get selector() {
    return '.comments__reply-more';
  }

  bindCommentsReply() {
    let video = window.kmklabs.video;
    let notEligibleToComment = (video && video.premium == "true" && video.source == false)

    $(document).on('click', this.selector, function(event){
      var target = $(event.target);
      event.preventDefault();
      var video_id = $("meta[name='page']").attr('data-id');
      var commentable_id = target.data('id');
      $.get('/comments/reply', {'commentable_id': commentable_id, 'video_id': video_id})
        .always(
          function(data) {
            this.appendComments(commentable_id, data);
            new ShowMoreContent('.js-comment-container', '.truncate .read-more-comment', '.hidden'); // comments

            if (notEligibleToComment) {
              CommentVideoSection.hideReplyButton();
            }
          }.bind(this)
        );
      target.hide();
    }.bind(this));
  }

  appendComments(commentable_id, data) {
    var container = $('#reply-' + commentable_id);
    container.html(data);
    $("span.publish-date").timeago();

    new ComponentInitializers();
  }
}
